import { render, staticRenderFns } from "./TaskCertificateModal.vue?vue&type=template&id=697c45a1&"
import script from "./TaskCertificateModal.vue?vue&type=script&lang=js&"
export * from "./TaskCertificateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports